export const waitForBraze = () => {
  return new Promise((resolve) => {
    let index = 1;
    const interval = setInterval(() => {
      if (index > 10) {
        clearInterval(interval);
        resolve(null);
        return;
      }

      const { braze } = window;

      if (braze && braze.initialize()) {
        clearInterval(interval);
        resolve(braze);
      } else {
        index += 1;
      }
    }, 500);
  });
};

